module.exports = __webpack_public_path__ + "img/1-3.ef675c53.png";